import type { SpaceVisibility } from "@circle-react/types/Search/Space";

import type { SelectableVisibility } from "../types";

export const isSelectableVisibility = (
  value: SpaceVisibility | undefined,
): value is SelectableVisibility =>
  value === "open" || value === "private" || value === "secret";
